module.exports = __webpack_public_path__ + "img/P16-en.1664daf2.png";